var map = {
	"./case-history.svg": 7031,
	"./consultancy.svg": 5408,
	"./dispense-old.svg": 4235,
	"./dispense.svg": 5044,
	"./e-learning-old.svg": 1950,
	"./e-learning.svg": 3037,
	"./learning-beats-old.svg": 7536,
	"./learning-beats.svg": 9860,
	"./special-projects.svg": 159
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6467;